module.exports = __webpack_public_path__ + "static/media/card-image.4c879897.jpg";